export const STRIPE_JAVASCRIPT_API = 'https://js.stripe.com/v3/';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/stripe.js